import Vue from 'vue';
import Router from 'vue-router';
import Index from './components/index/Index';
import PrivacyPolicyPage from "@/views/PrivacyPolicyPage.vue";

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage
    },
    {
      path: '*',
      name: 'Index',
      component: Index
    },
    {
      path: '/galereya/*',
      name: 'GalleryInside',
      component: Index
    },
  ]
})
